<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{ name: 'LibraryList' }">文库</router-link>
      <span class="slash">/</span>
      <span class="current">{{ library.name }}</span>
    </div>
    <div class="detail" :class="library.file_ext">
      <img
        class="icon"
        src="../../images/library/doc@2x.png"
        v-if="library.file_ext == 'docx' || library.file_ext == 'doc'"
      />
      <img
        class="icon"
        src="../../images/library/xls@2x.png"
        v-else-if="library.file_ext == 'xlsx' || library.file_ext == 'xls'"
      />
      <img
        class="icon"
        src="../../images/library/pdf@2x.png"
        v-else-if="library.file_ext == 'pdf'"
      />
      <div class="title">{{ library.name }}</div>
      <div class="author-wrap">
        <span class="author">作者：{{ library.author }}</span>
        <span class="line">|</span>
        <span>{{ library.created_at | tsFormat('yyyy/MM/dd') }}</span>
        <span class="broswer-num"> {{ library.browse_num + library.browse_base }}人浏览 </span>
      </div>
      <div class="instruction">{{ library.instruction }}</div>
      <div class="operate">
        <a href="javascript:void(0)" class="share" @click="shareLibrary"></a>
      </div>
      <div>
        <a class="download" @click="download">下载文档</a>
      </div>
    </div>
    <div class="main clear">
      <div class="left">
        <BlockTabs :items="[{ id: 1, name: '文档预览' }]"></BlockTabs>
        <div class="preview">
          <iframe
            v-if="
              (library.file_ext == 'docx' ||
                library.file_ext == 'doc' ||
                library.file_ext == 'xlsx' ||
                library.file_ext == 'xls') &&
              downloadUrl != ''
            "
            :src="'https://view.officeapps.live.com/op/view.aspx?src=' + downloadUrl"
            width="100%"
            height="1000px"
            frameborder="0"
          ></iframe>
          <div id="pdfViewer" v-else-if="library.file_ext == 'pdf' && downloadUrl != ''"></div>
        </div>
      </div>
      <div class="right">
        <div class="header">
          <img src="../../images/library/document@2x.png" />
          <span>相关文档推荐</span>
        </div>
        <div class="item" v-for="item in recommends" :key="item.id">
          <a :href="'/library/' + item.id">
            <div class="name">
              <img
                class="icon"
                src="../../images/library/doc@2x.png"
                v-if="item.file_ext == 'docx' || item.file_ext == 'doc'"
              />
              <img
                class="icon"
                src="../../images/library/xls@2x.png"
                v-else-if="item.file_ext == 'xlsx' || item.file_ext == 'xls'"
              />
              <img
                class="icon"
                src="../../images/library/pdf@2x.png"
                v-else-if="item.file_ext == 'pdf'"
              />
              <span>{{ item.name }}</span>
            </div>
          </a>
          <div class="instruction">{{ item.instruction }}</div>
        </div>
      </div>
    </div>
    <el-dialog title="分享" :visible.sync="showShareModal" width="400px">
      <vue-qr :text="shareUrl" :size="200" class="center"></vue-qr>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showShareModal = false"> 确 定 </el-button>
      </span>
    </el-dialog>
    <el-dialog title="下载" :visible.sync="showDownloadModal" width="400px">
      <el-progress :percentage="downloadPercent"></el-progress>
      <div slot="footer" class="dialog-footer"></div>
    </el-dialog>
  </div>
</template>
<script>
import VueQr from 'vue-qr';
export default {
  name: 'LibraryDetail',
  components: {
    VueQr,
  },
  data() {
    return {
      id: this.$route.params.id,
      library: {},
      showShareModal: false,
      shareUrl: '',
      downloadUrl: '',
      recommends: [],
      showDownloadModal: false,
      downloadPercent: 0,
    };
  },
  async created() {
    await this.incrementBrosweNum();
    this.recommends = await this.$http.get('/api/app/library/recommend/' + this.id);
  },
  mounted() {
    this.$nextTick(async () => {
      this.library = await this.$http.get('/api/app/library/detail/' + this.id);
      await this.getDownloadUrl();
      if (this.library.file_ext == 'pdf') {
        let options = {
          height: '850px',
          width: '100%',
          pdfOpenParams: { view: 'FitV', page: '0' },
          name: 'mans',
          fallbackLink: '<p class="center">您的浏览器暂不支持此pdf，请下载最新的浏览器</p>',
        };
        window.PDFObject.embed(this.downloadUrl, '#pdfViewer', options);
      }
    });
  },
  methods: {
    async incrementBrosweNum() {
      await this.$http.put('/api/app/library/pv/' + this.id);
      this.library.browse_num++;
    },
    async collect() {
      this.library.is_collected = await this.$http.post(
        '/api/app/collect',
        {
          library_id: this.id,
          type: 5,
        },
        true,
      );
      this.library.is_collected = true;
      await this.$success('收藏成功');
    },
    async cancelCollect() {
      await this.$http.put('/api/app/collect/cancel/' + this.library.is_collected + '/5');
      this.library.is_collected = false;
      await this.$success('取消收藏成功');
    },
    shareLibrary() {
      this.shareUrl = this.$store.state.commonSetting.h5_address + '/library-detail?id=' + this.id;

      this.showShareModal = true;
    },
    async getDownloadUrl() {
      let data = await this.$http.get('/api/app/library/download/' + this.id);
      this.downloadUrl = data.download_url || data.file_content;
    },
    download() {
      this.downloadPercent = 0;
      this.showDownloadModal = true;
      let xhr = new XMLHttpRequest();
      xhr.open('get', this.downloadUrl + '?' + new Date().getTime());
      xhr.responseType = 'blob';
      xhr.onprogress = (evt) => {
        this.downloadPercent = parseInt((evt.loaded * 100) / evt.total);
      };
      xhr.onreadystatechange = async () => {
        if (xhr.readyState == 4 && xhr.status == 200) {
          let blob = xhr.response;
          let blobUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = blobUrl;
          link.download = this.library.name + '.' + this.library.file_ext;
          link.click();
          setTimeout(() => {
            this.showDownloadModal = false;
          }, 500);
        }
      };
      xhr.send();
    },
  },
};
</script>
<style lang="scss" scoped>
.detail {
  background-color: white;
  box-shadow: 0px 16px 20px 0px rgba(0, 0, 0, 0.07);
  margin-left: 16px;
  padding: 30px 30px 30px 53px;
  position: relative;
  margin-bottom: 30px;
  background-position: right bottom;
  background-size: 149px 150px;
  background-repeat: no-repeat;
  &.pdf {
    background-image: url('~@/modules/stu/images/library/detail-back-pdf@3x.png');
  }
  &.xls {
    background-image: url('~@/modules/stu/images/library/detail-back-xls@3x.png');
  }
  &.doc {
    background-image: url('~@/modules/stu/images/library/detail-back-doc@3x.png');
  }
  .icon {
    position: absolute;
    width: 49px;
    top: 30px;
    left: -16px;
  }
  .title {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(32, 36, 42, 1);
    line-height: 27px;
    letter-spacing: 1px;
    margin-bottom: 16px;
    max-width: 700px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .author-wrap {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #8c8c8c;
    line-height: 20px;
    letter-spacing: 1px;
    margin-bottom: 30px;
    .author {
      font-weight: 500;
      color: rgba(32, 36, 42, 1);
    }
    .line {
      margin: 0 22px;
    }
    .broswer-num {
      margin-left: 50px;
    }
  }
  .instruction {
    max-height: 68px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(140, 140, 140, 1);
    line-height: 23px;
    letter-spacing: 1px;
    overflow: hidden;
    margin-bottom: 30px;
  }
  .download {
    width: 116px;
    height: 40px;
    background-color: $primary-color-light;
    border-radius: 21px;
    color: $primary-color;
    display: inline-block;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    &:hover {
      background-color: $primary-color;
      color: white;
    }
  }
  .operate {
    position: absolute;
    top: 30px;
    right: 30px;
    line-height: 1;
    display: flex;
  }
  .collect,
  .share {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8c8c8c;
    cursor: pointer;
  }
  .collect {
    background-size: 15px 14px;
    background-repeat: no-repeat;
    background-position: left 1px;
    padding-left: 22px;
    margin-right: 21px;
  }
  .collect-none {
    background-image: url('~@/assets/images/course/collect-none@2x.png');
  }
  .collect-has {
    background-image: url('~@/assets/images/course/collect@3x.png');
  }
  .share {
    width: 20px;
    height: 20px;
    background-image: url('~@/assets/images/common/share@2x.png');
    background-size: 100% 100%;

    &:hover {
      background-image: url('~@/assets/images/common/share-hover@2x.png');
    }
  }
}
.main {
  margin-bottom: 50px;
  .tabs {
    background: rgba(247, 248, 250, 1);
  }
  .left {
    width: 977px;
    background-color: white;
    float: left;
    .preview {
      padding: 32px;
    }
  }
  .right {
    width: 193px;
    float: right;
    .header {
      background-color: white;
      padding: 15px;
      border-radius: 10px;
      img {
        width: 14px;
        margin-right: 7px;
        vertical-align: middle;
      }
      span {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #5b6066;
        line-height: 22px;
        vertical-align: middle;
      }
    }
    .item {
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
      padding: 15px;
      margin-top: 15px;
      .name {
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 10px;
        overflow: hidden;
        img {
          width: 10px;
          margin-right: 6px;
          vertical-align: middle;
        }
        span {
          height: 21px;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(32, 36, 42, 1);
          line-height: 21px;
          vertical-align: middle;
          &:hover {
            color: $primary-color;
          }
        }
      }
      .instruction {
        max-height: 51px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
        line-height: 17px;
        overflow: hidden;
      }
    }
  }
}
</style>
<style lang="scss">
html,
body {
  background: rgba(247, 248, 250, 1);
}
</style>
